import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import {
  Icon,
  Progress,
  Modal,
} from 'semantic-ui-react';
import api from '../../../api';
import Loader from '../../Loader/Loader';

class ImportingFile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      file: props.file,
      isModalLoader: false,
      isOpenPopup: false,
      isOpenErrorModal: false,
    };
    this.stopFileUploading = this.stopFileUploading.bind(this);
    this.handleRemoveReport = this.handleRemoveReport.bind(this);
    this.deleteReport = this.deleteReport.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps) {
    const { file } = this.props;
    if (prevProps.file.scan_progress !== file.scan_progress) {
      this.drawProgress(file.scan_progress);
    }

    if (prevProps.file.uploaded_progress !== file.uploaded_progress) {
      this.drawUploadedProgress(file.uploaded_progress);
    }

    if (prevProps.file.scan_status_detail !== file.scan_status_detail) {
      this.drawStatusDetail(file.scan_status_detail);
    }

    if (prevProps.file.scan_status !== file.scan_status) {
      this.setState({
        file,
      });
    }
  }

  componentWillUnmount() {
  }

  deleteReport = () => {
    const { selectedId } = this.state;
    const { deleteCallback, translate } = this.props;

    this.setState({
      isModalLoader: true,
    });

    const obj = {
      front_id: selectedId,
    };

    api
      .newScanDelete(obj)
      .then((response) => {
        const data = response.response;
        this.setState({
          isModalLoader: false,
          isOpenPopup: false,
        }, () => {
          deleteCallback(data);
        });
      })
      .catch((err) => {
        console.log(err);
        this.modalAction = translate('modal.title.attention');
        const o = err.data.response;
        if (o.error === '422-201') {
          this.modalBody = translate('modal.error.error_422_201');
        }

        if (o.error === '422-206') {
          this.modalBody = translate('modal.error.error_422_206');
        }

        if (o.error === '422-021') {
          this.modalBody = translate('modal.error.error_422_021');
        }

        if (o.error === '422-366') {
          this.modalBody = o.error_description;
        }

        this.setState({
          isOpenPopup: false,
          isModalLoader: false,
          isOpenErrorModal: true,
        });
      });
  };

  drawStatusDetail = (scanStatusDetail) => {
    this.setState((prevState) => {
      return {
        file: {
          ...prevState.file,
          scan_status_detail: scanStatusDetail,
        },
      };
    });
  };

  drawProgress = (progress) => {
    this.setState((prevState) => {
      return {
        file: {
          ...prevState.file,
          scan_progress: progress,
        },
      };
    });
  };

  drawUploadedProgress = (progress) => {
    this.setState((prevState) => {
      return {
        file: {
          ...prevState.file,
          uploaded_progress: progress,
        },
      };
    });
  };

  handleRemoveReport = (name, frontId) => {
    const { translate } = this.props;
    this.modalAction = translate('modal.title.attention');
    this.modalBody = translate('modal.message.q_delete_file');

    this.setState({
      selectedName: name,
      selectedId: frontId,
      isOpenPopup: true,
    });
  };

  stopFileUploading = (name, id) => {
    const { stopFileUploading } = this.props;
    stopFileUploading(name, id);
  };

  closeModal() {
    this.setState({
      isOpenPopup: false,
      isOpenErrorModal: false,
    });
  }

  renderProgress = (rowData) => {
    const { state, translate } = this.props;
    const { uploadingProgressArray } = state.report;
    const sliced = uploadingProgressArray.slice();

    const currentIndex = sliced.findIndex((item) => {
      return item.frontId === rowData.front_id;
    });

    if (currentIndex === -1) {
      return (
        <p className="scan_file">
          <Icon name="wait" />
          {translate('modal.error.uploading_failed')}
          {rowData.name}
        </p>
      );
    }

    return (
      <div className="progress_wrap">
        <div className="progress_info">
          <span className="state">{rowData.scan_status === 7 ? translate('modal.title.compressing') : translate('modal.title.uploading')}</span>
          <span className="quota">
            {sliced[currentIndex].status}
            % /
            {' '}
            {rowData.uploaded_size}
          </span>
          <span className="time">-</span>
        </div>
        <div className="progress_bar_wrap">
          <Progress
            percent={sliced[currentIndex].status}
            //progress="percent"
            size="tiny"
            active={sliced[currentIndex].status >= 0 && sliced[currentIndex].status <= 100}
            indicating
          />
        </div>
      </div>
    );
  };

  renderProgressWithServer = (rowData) => {
    const { translate } = this.props;
    return (
      <div className="progress_wrap">
        <div className="progress_info">
          <span className="state">{translate('modal.title.uploading')}</span>
          <span className="quota">
            {rowData.uploaded_progress}
            % /
            {' '}
            {rowData.uploaded_size}
          </span>
          <span className="time">-</span>
        </div>
        <div className="progress_bar_wrap">
          <Progress
            percent={rowData.uploaded_progress}
            //progress="percent"
            size="tiny"
            active={rowData.uploaded_progress >= 0 && rowData.uploaded_progress <= 100}
            indicating
          />
        </div>
      </div>
    );
  };

  render() {
    const {
      file, isOpenPopup, isModalLoader, selectedName, isOpenErrorModal
    } = this.state;

    const { translate } = this.props;

    return (
      <table className="scanning_files_table">
        <colgroup>
          <col style={{ width: '50%' }} />
          <col style={{ width: '45%' }} />
          <col style={{ width: '30px' }} />
        </colgroup>
        <tbody>
          {
            file.scan_status === 0
            && (
              <tr>
                <td>
                  <p className="file_name"><span>{file.name}</span></p>
                  <p className="project_name">
                    <span>{file.project_name}</span>
                    <span>/</span>
                    <span>{file.project_version_name}</span>
                  </p>
                </td>
                <td>
                  <p className="scan_file">
                    <Icon name="wait" />
                    {translate('modal.title.scan_queued')}
                  </p>
                </td>
                <td>
                  {
                    file.has_manage_permission ? (
                      <div className="button_wrap">
                        <a
                          className="delete"
                          onClick={() => { return this.handleRemoveReport(file.name, file.front_id); }}
                          onKeyUp={() => { return this.handleRemoveReport(file.name, file.front_id); }}
                        >
                          <Icon
                            name="cancel"
                          />
                        </a>
                      </div>
                    ) : null
                  }
                </td>
              </tr>
            )
          }
          {
            file.scan_status === 1
            && (
              <tr>
                <td>
                  <p className="file_name"><span>{file.name}</span></p>
                  <p className="project_name">
                    <span>{file.project_name}</span>
                    <span>/</span>
                    <span>{file.project_version_name}</span>
                  </p>
                </td>
                <td>
                  <div className="progress_wrap">
                    <div className="progress_info">
                      <span className="state">{translate('modal.title.scanning')}</span>
                      <span className="quota">
                        {file.scan_progress}
                        % /
                        {file.uploaded_size}
                      </span>
                      <span className="time">{file.scan_status_detail}</span>
                    </div>
                    <div className="progress_bar_wrap">
                      <Progress
                        percent={file.scan_progress}
                        //progress="percent"
                        size="tiny"
                        active={file.scan_progress >= 0 && file.scan_progress <= 100}
                        indicating
                      />
                    </div>
                  </div>
                </td>
                <td>
                  {
                    file.has_manage_permission ? (
                      <div className="button_wrap">
                        <a
                          className="delete"
                          onClick={() => { return this.handleRemoveReport(file.name, file.front_id); }}
                          onKeyUp={() => { return this.handleRemoveReport(file.name, file.front_id); }}
                        >
                          <Icon
                            name="cancel"
                          />
                        </a>
                      </div>
                    ) : null
                  }
                </td>
              </tr>
            )
          }
          {
            file.scan_status === 3
            && (
              <tr>
                <td>
                  <p className="file_name"><span>{file.name}</span></p>
                  <p className="project_name">
                    <span>{file.project_name}</span>
                    <span>/</span>
                    <span>{file.project_version_name}</span>
                  </p>
                </td>
                <td>
                  <p className="scan_file">
                    <Icon name="info circle" />
                    {translate('modal.title.scan_failed')}
                  </p>
                </td>
                <td>
                  {
                    file.has_manage_permission ? (
                      <div className="button_wrap">
                        <a
                          className="delete"
                          onClick={() => { return this.handleRemoveReport(file.name, file.front_id); }}
                          onKeyUp={() => { return this.handleRemoveReport(file.name, file.front_id); }}
                        >
                          <Icon
                            name="cancel"
                          />
                        </a>
                      </div>
                    ) : null
                  }
                </td>
              </tr>
            )
          }
          {
            file.type && file.scan_status === 5 //uploading progress update with local
              && (
                <tr>
                  <td>
                    <p className="file_name"><span>{file.name}</span></p>
                    <p className="project_name">
                      <span>{file.project_name}</span>
                      <span>/</span>
                      <span>{file.project_version_name}</span>
                    </p>
                  </td>
                  <td>
                    {this.renderProgress(file)}
                  </td>
                  {
                    /*
                    <td>
                    {
                      file.has_manage_permission ? (
                        <div className="button_wrap">
                          <a
                            className="delete"
                            onClick={() => { return this.stopFileUploading(file.name, file.front_id); }}
                            onKeyUp={() => { return this.stopFileUploading(file.name, file.front_id); }}
                          >
                            <Icon
                              name="cancel"
                            />
                          </a>
                        </div>
                      ) : null
                    }
                  </td>
                  */
                  }
                </tr>
              )
          }
          {
            file.scan_status === 6 //custom status. front only. api call with url
              && (
                <tr>
                  <td>
                    <p className="file_name"><span>{file.name}</span></p>
                    <p className="project_name">
                      <span>{file.project_name}</span>
                      <span>/</span>
                      <span>{file.project_version_name}</span>
                    </p>
                  </td>
                  <td>
                    <p className="scan_file">
                      <Icon name="wait" />
                      {translate('modal.title.prepare_to_upload')}
                    </p>
                  </td>
                  <td>
                    {/*
                      file.has_manage_permission ? (
                        <div className="button_wrap">
                          <a
                            className="delete"
                            onClick={() => { return this.stopFileUploading(file.name, file.front_id); }}
                            onKeyUp={() => { return this.stopFileUploading(file.name, file.front_id); }}
                          >
                            <Icon
                              name="cancel"
                            />
                          </a>
                        </div>
                      ) : null
                    */}
                  </td>
                </tr>
              )
          }
          {
            file.scan_status === 7 //compressing status
              && (
                <tr>
                  <td>
                    <p className="file_name"><span>{file.name}</span></p>
                    <p className="project_name">
                      <span>{file.project_name}</span>
                      <span>/</span>
                      <span>{file.project_version_name}</span>
                    </p>
                  </td>
                  <td>
                    {this.renderProgress(file)}
                  </td>
                  <td>
                    {/*
                      file.has_manage_permission ? (
                        <div className="button_wrap">
                          <a
                            className="delete"
                            onClick={() => { return this.stopFileUploading(file.name, file.front_id); }}
                            onKeyUp={() => { return this.stopFileUploading(file.name, file.front_id); }}
                          >
                            <Icon
                              name="cancel"
                            />
                          </a>
                        </div>
                      ) : null
                    */}
                  </td>
                </tr>
              )
          }
          {
            !file.type && file.scan_status === 5 //uploading progress update with url scan
              && (
                <tr>
                  <td>
                    <p className="file_name"><span>{file.name}</span></p>
                    <p className="project_name">
                      <span>{file.project_name}</span>
                      <span>/</span>
                      <span>{file.project_version_name}</span>
                    </p>
                  </td>
                  <td>
                    {this.renderProgressWithServer(file)}
                  </td>
                  <td>
                    {/*
                      file.has_manage_permission ? (
                        <div className="button_wrap">
                          <a
                            className="delete"
                            onClick={() => { return this.handleRemoveReport(file.name, file.front_id); }}
                            onKeyUp={() => { return this.handleRemoveReport(file.name, file.front_id); }}
                          >
                            <Icon
                              name="cancel"
                            />
                          </a>
                        </div>
                      ) : null
                    */}
                  </td>
                </tr>
              )
          }
          <Modal
            open={isOpenPopup}
            className="modal"
          >
            <div className="modal_popup_wrap confirm_wrap">
              <div className="modal_popup_box confirm_box">
                {
                  isModalLoader ? (
                    <Loader />
                  ) : (
                    <div className="modal_popup confirm">
                      <h2 className="title">{this.modalAction}</h2>
                      <p className="text">{this.modalBody}</p>
                      <p className="small_text" style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>
                        &quot;
                        {selectedName}
                        &quot;
                      </p>
                      <div className="button_wrap">
                        <a
                          className="left_button"
                          onClick={this.closeModal}
                          onKeyUp={this.closeModal}
                        >
                          {translate('modal.button.cancel')}
                        </a>
                        <a
                          className="right_button"
                          onClick={this.deleteReport}
                          onKeyUp={this.deleteReport}
                        >
                          {translate('modal.button.delete')}
                        </a>
                      </div>
                    </div>
                  )
                }
              </div>
            </div>
          </Modal>
          <Modal
            open={isOpenErrorModal}
            onClose={this.closeModal}
            className="modal"
          >
            <div className="modal_popup_wrap confirm_wrap">
              <div className="modal_popup_box confirm_box">
                {
                  isModalLoader ? (
                    <Loader />
                  ) : (
                    <div className="modal_popup confirm">
                      <h2 className="title">{this.modalAction}</h2>
                      <p className="text">{this.modalBody}</p>
                      <p className="small_text" style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>
                        &quot;
                        {selectedName}
                        &quot;
                      </p>
                      <div className="button_wrap">
                        <a
                          className="center_button"
                          onClick={this.closeModal}
                          onKeyUp={this.closeModal}
                        >
                          {translate('modal.button.close')}
                        </a>
                      </div>
                    </div>
                  )
                }
              </div>
            </div>
          </Modal>
        </tbody>
      </table>
    );
  }
}
export default inject('state')(observer(ImportingFile));
